<template>
  <button
    class="purchase-btn"
    @click.stop="handleSquareBtnClick"
  >
    {{ localizedText  }}
  </button>
</template>

<script>
import t from '@/plugins/i18n';

export default {
  name: 'BuyButton',
  mixins: [t],

  props: {
    text: {
      type: String,
      default: null,
    },
  },

  computed: {
    localizedText() {
      return this.text || this.t('購入する');
    },
  },

  methods: {
    handleSquareBtnClick() {
      this.$emit('handleSquareBtnClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.purchase-btn {
  background: linear-gradient(to top,#fd0200,#ffbc63);
  color: white;
  font-size: 14px;
  font-weight: bold;
  border: none;
  border-radius: 50px;
  padding: 10px 25px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s ease;
  position: relative;
  justify-content: center;
  overflow: hidden; // 光がはみ出ないようにする

  // 光のエフェクトを別レイヤーに配置
}
@keyframes shine {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

@media screen and (max-width: $tabletWidth) {
  .purchase-btn {
    padding: 5px 15px;
    font-size: 10px;
  }
}
</style>
